/*
 * 权限相关全局代码
 */

$.extend(tower, {
    initPermission: function( el ) {
        var el = $(el).is("[data-visible-to]") ? $(el) : $("[data-visible-to]", el);
        el.each(function() {
            var item = $( this );
            var available = false;
            var visibleTo = item.data("visible-to").split(",");

            if ($.inArray("admin", visibleTo) > -1) {
                var projectEl = item.closest('[data-project-creator]');
                if (tower.me.admin || (projectEl.length && projectEl.data('project-creator') === tower.me.guid)) {
                    available = true;
                }
            }

            if ($.inArray( "creator", visibleTo ) > -1) {
                var resourceEl = item.closest("[data-creator-guid]");
                if (resourceEl.length && tower.me.guid == resourceEl.data("creator-guid")) {
                    available = true;
                }
            }

            if (!tower.me.visitor && $.inArray("member", visibleTo) > -1) {
                available = true;
            }

            if (!available) {
                if (item.siblings().length < 1) {
                    item.parent().hide();
                }
                if (item.closest('.mdc-list-item')) {
                    item.closest('.mdc-list-item').remove()
                }
                item.remove();
            }
        });
    }
});
